import script from "./order-detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./order-detail.vue?vue&type=script&setup=true&lang=ts"

import "./order-detail.vue?vue&type=style&index=0&id=45c66232&scoped=true&lang=scss"
import "./order-detail.vue?vue&type=style&index=1&id=45c66232&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45c66232"]])

export default __exports__